module.exports = __webpack_public_path__ + "img/国寿改版.52af6b9b.png";